export default __webpack_public_path__ + "static/media/PDF.547b03c7.png";